import React from 'react'
import { Check, Play, Download } from 'lucide-react'

const APP_STORE_URL = 'https://apps.apple.com/za/app/zoelive-prayer'
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.zoelive.prayer'

const FinalCTA = ({ trackEvent }) => {
  const benefits = [
    'Free forever',
    'No credit card',
    '7-day Premium trial',
    'Cancel anytime',
  ]

  return (
    <section id="download" className="section-padding bg-gradient-to-r from-prayer-blue to-pod-green relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="container-custom relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Headline */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 animate-on-scroll">
            Your Phone Can Finally Help You Pray
          </h2>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto animate-on-scroll">
            Join 127,000+ believers who've turned distraction into devotion.
            Start your first streak today — no credit card, no commitment, just prayer.
          </p>

          {/* Primary CTA */}
          <div className="flex flex-col items-center gap-6 mb-8 animate-on-scroll">
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent('final_cta_click', { button_text: 'Download Free' })}
              className="bg-white text-prayer-blue font-bold text-xl px-12 py-5 rounded-lg shadow-2xl transition-all duration-300 hover:scale-105 hover:shadow-3xl inline-flex items-center gap-3"
            >
              <Download size={24} />
              Download Free for iOS & Android
            </a>

            {/* App Store Badges */}
            <div className="flex flex-wrap gap-4 justify-center">
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('app_store_click', { store: 'ios' })}
                className="bg-black text-white px-6 py-3 rounded-lg font-semibold text-sm hover:bg-gray-800 transition-all"
              >
                Download on the App Store
              </a>
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('app_store_click', { store: 'android' })}
                className="bg-black text-white px-6 py-3 rounded-lg font-semibold text-sm hover:bg-gray-800 transition-all"
              >
                Get it on Google Play
              </a>
            </div>
          </div>

          {/* Benefits Checklist */}
          <div className="flex flex-wrap justify-center gap-6 mb-8 animate-on-scroll">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-center gap-2 text-white">
                <Check size={20} className="flex-shrink-0" />
                <span className="font-medium">{benefit}</span>
              </div>
            ))}
          </div>

          {/* Secondary CTA */}
          <button
            onClick={() => {
              trackEvent('final_demo_click')
              document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })
            }}
            className="text-white font-semibold inline-flex items-center gap-2 hover:underline transition-all animate-on-scroll"
          >
            <Play size={20} />
            Prefer to see how it works first? Click here
          </button>

          {/* Optional: Floating Phone Mockup */}
          <div className="mt-16 animate-on-scroll">
            <div className="max-w-xs mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-4 border-2 border-white/20">
                <div className="bg-white rounded-2xl p-6 aspect-[9/19] flex items-center justify-center">
                  <div className="text-center">
                    <div className="text-6xl mb-4">&#x1F64F;</div>
                    <div className="text-prayer-blue font-bold text-xl">Start Prayer Mode</div>
                    <div className="text-muted-gray text-sm mt-2">Tap to begin</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FinalCTA
